import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'crop-5-4-filled', 'Crop54Filled', [["path",{"d":"M18 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z"}]]);